// Mirrors the backend's addAdmindefaultparams(): a row saved before data_type existed carries none.
const KNOWN_SETTING_TYPES = {
    contact_number: "number", delivery_charge: "number", delivery_charge_per_km: "number",
    minimum_dynamic_delivery_charge: "number", delivery_charge_limit: "number", delivery_radius: "number",
    delivery_boy_commission: "number", express_delivery_charge: "number", admin_estimated_time: "number",
    check_order_time_in_seconds: "number", order_cancellation_time_in_minutes: "number",
    minimum_cart_value: "number", Extra_charge: "number", free_delivery_radius: "number",
    dynamic_delivery_charge: "bool", cumilative_dynamic_delivery_charge: "bool", open: "bool",
    dynamic_delivery_boy_commission: "bool", new_order_alert_sound: "bool", refund_to_wallet: "bool", edit_raise_from_wallet: "bool",
    Enable_extra_charge: "bool", free_delivery_all_restaurants: "bool", COD_Payment_Enabled: "bool",
};

// TblAdminConfigurations.param_value is a 300-character column.
const MAX_TEXT_LENGTH = 300;
const AMOUNT = /^\d+(\.\d{1,2})?$/;

export const resolveDataType = (setting) =>
    setting.data_type || KNOWN_SETTING_TYPES[setting.param_name] || "string";

export const validateSettingValue = ({ name, value, data_type }) => {
    const text = String(value ?? "").trim();
    if (text === "") return "Value should not be empty";
    if (name === "contact_number" && !/^\d{10}$/.test(text)) return "Mobile number should be 10 digit";
    const type = resolveDataType({ param_name: name, data_type });
    if (type === "number" && !AMOUNT.test(text)) return "Enter a number using digits only, up to 2 decimals";
    if (type === "bool" && text !== "true" && text !== "false") return "Choose Yes or No";
    if (type === "string" && text.length > MAX_TEXT_LENGTH) return `Keep the text under ${MAX_TEXT_LENGTH} characters`;
    return null;
}

//js compare two arrays with a key-value
export const validateWithSettingsExcludeList = (allSettings, excludedSettings) => {
    return allSettings?.filter(o1 => !excludedSettings.some(o2 => o1.param_name === o2));
}

// delivery_radius is left out on purpose: Settings.js only lets a superuser
// save it, so showing it to staff would offer an edit that silently does nothing.
export const STAFF_VISIBLE_SETTINGS = [
  "Enable_extra_charge",
  "Extra_charge",
  "Extra_charge_description",
];

export const limitSettingsForStaff = (allSettings, isStaffOnly) => {
  if (!isStaffOnly) return allSettings;
  return (allSettings || []).filter((setting) =>
    STAFF_VISIBLE_SETTINGS.includes(setting.param_name)
  );
};

// The backend lets staff read and save every setting of their franchise's
// restaurants (ClsConfig accepts FranchiseUsertype.franchise_), so the narrowing
// above belongs to the franchise settings page only.
export const limitSettingsForStaffOnPage = (allSettings, isStaffOnly, restaurantId) =>
  restaurantId ? allSettings : limitSettingsForStaff(allSettings, isStaffOnly);

// Every client reads only the SUPERUSER copy of these. franchise/views.py:670-685
// returns both a per-franchise value (fran_user_app_pp, fran_terms_and_conditions,
// fran_refund_policy) and a superuser one, and the customer app takes the superuser
// fields exclusively — as do the other five clients, none of which reference the
// fran_* keys at all. So a franchise-level edit changes nothing anywhere, and
// showing it offers an edit that silently does nothing, exactly as with
// delivery_radius above.
export const SUPERUSER_ONLY_SETTINGS = [
  "user_app_privacy_policy",
  "terms_and_conditions",
  "refund_policy",
  "website",
];

export const limitSettingsForFranchiseUsers = (allSettings, isSuperuser) => {
  if (isSuperuser) return allSettings;
  return (allSettings || []).filter(
    (setting) => !SUPERUSER_ONLY_SETTINGS.includes(setting.param_name)
  );
};
